export default {
  // en_gb: {
  //   navbar: {
  //     logo: 'just-eat-logo',
  //     country_toggle: '',
  //     country_link: '',
  //   },
  //   cookie: {
  //     text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
  //     url: 'https://www.just-eat.co.uk/info/cookies-policy',
  //     url_text: 'Learn more about our cookies policy.',
  //     button: 'OK',
  //   },
  //   market: {
  //     name: 'Just Eat',
  //     url: 'https://www.just-eat.co.uk/',
  //   },
  //   title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
  //   one: [
  //     'Just Eat (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
  //     'Name:  UNHCR Nederland',
  //     'Registration number (RSIN): 82 39 59 636',
  //     'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
  //     'Address: Alexanderveld 5, 2585 AN Den Haag',
  //   ],
  //   two: {
  //     text: 'You can make donations to UNHCR by clicking the following ',
  //     link: 'link',
  //     url: 'https://www.unrefugees.org.uk/ukraine-justeat?utm_source=donate.unhcr.org&utm_medium=referral&utm_campaign=GB_PS_EN_UA___justeat-ctg',
  //   },
  //   three:
  //     'By clicking on the link above, you hereby agree to these terms and conditions.',
  //   four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
  //   five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
  //   six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
  //   seven:
  //     'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
  //   eight:
  //     'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
  //   nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
  //   ten: {
  //     one: 'All standard terms and conditions from time to time for use of ',
  //     two: ' website and services apply.',
  //   },
  //   conditions: {
  //     link: 'Terms & Conditions',
  //     url: 'https://www.just-eat.co.uk/info/terms-and-conditions',
  //   },
  //   privacy: {
  //     link: 'Privacy statement',
  //     url: 'https://www.just-eat.co.uk/info/privacy-policy',
  //   },
  //   copyright: '© 2022 Just Eat',
  // },
  ie_ie: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: '',
      country_link: '',
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.ie/info/cookies-policy',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.ie/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Just Eat (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donate.unhcr.org/int/en/ukraine-emergency-justeat-ie-ctg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=HQ_PS_EN_UA___ireland-justeat-bg-emg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.ie/info/terms-and-conditions',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.ie/info/privacy-policy',
    },
    copyright: '© 2022 Just Eat',
  },
  dk_en: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.just-eat.dk/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'dk',
          url: 'https://www.just-eat.dk/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.dk/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.dk/en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Just Eat Takeaway.com (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://stoet.unhcr.org/dk/da/ukraine-justeat?utm_source=partnerships&utm_medium=partnerships&utm_campaign=DK_PS_DA_UA___justeat-ctg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.dk/en/info/terms-and-conditions',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.dk/en/info/privacy-policy',
    },
    copyright: '© 2022 Just Eat',
  },
  fr_en: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.just-eat.fr/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'fr',
          url: 'https://www.just-eat.fr/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.fr/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.fr/en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Just Eat (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donner.unhcr.org/urgence-ukraine-justeat/?utm_source=partnerships&utm_medium=partnerships&utm_campaign=FR_PS_FR_UA___justeat-ctg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.fr/en/info/terms-and-conditions',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.fr/en/info/privacy-policy',
    },
    copyright: '© 2022 Just Eat',
  },
  de_en: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.lieferando.de/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'de',
          url: 'https://www.lieferando.de/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.lieferando.de/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Liferando.de',
      url: 'https://www.lieferando.de/en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Liferando.de (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://www.uno-fluechtlingshilfe.de/lieferandohilft?donation_custom_field_1628=W-12141&utm_source=lieferando&utm_medium=referral&utm_campaign=DE_PS_DE_APPEAL_UA',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.lieferando.de/en/info/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.lieferando.de/en/info/privacy-statement',
    },
    copyright: '© 2022 Lieferando.de',
  },
  at_en: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.lieferando.at/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'at',
          url: 'https://www.lieferando.at/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.lieferando.at/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Lieferando.at',
      url: 'https://www.lieferando.at/en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Lieferando (part of Just Eat Takeaway.com group) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://www.uno-fluechtlingshilfe.de/spenden-ukraine?donation_custom_field_1628=W-12152&utm_source=justeatAT&utm_medium=referral&utm_campaign=DE_PS_DE_APPEAL_UA',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.lieferando.at/en/info/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.lieferando.at/en/info/privacy-statement',
    },
    copyright: '© 2022 Lieferando.at',
  },
  be_en: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/be-en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'nl',
          url: 'https://www.takeaway.com/be/deals/ukraine-donation-terms/',
        },
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/be-fr/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/be-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/be-en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Takeaway.com (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donate.unhcr.org/be/fr-be/ukraine-emergency-justeat-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=BE_PS_FR_UA___belgium-french-justeat-ctg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.takeaway.com/be-en/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/be-en/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  ro_en: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/ro-en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'ro',
          url: 'https://www.takeaway.com/ro/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/ro-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/ro-en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Takeaway.com (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donate.unhcr.org/int/en/ukraine-emergency-justeat-ro-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=HQ_PS_EN_UA___romania-justeat-bg-emg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.takeaway.com/ro-en/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/ro-en/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  bg_en: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/bg-en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'bg',
          url: 'https://www.takeaway.com/bg/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/bg-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/bg-en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Takeaway.com (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donate.unhcr.org/int/en/ukraine-emergency-justeat-bg-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=HQ_PS_EN_UA___bulgaria-justeat-bg-emg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.takeaway.com/bg-en/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/bg-en/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  nl_en: {
    navbar: {
      logo: 'thuisbezorgd-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.thuisbezorgd.nl/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'nl',
          url: 'https://www.thuisbezorgd.nl/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.thuisbezorgd.nl/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Thuisbezorgd.com',
      url: 'https://www.thuisbezorgd.nl/en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Thuisbezorgd.nl (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://doneer.unhcr.nl/oekraine-t',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.thuisbezorgd.nl/en/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/be-en/privacy-statement',
    },
    copyright: '© 2022 Thuisbezorgd.com',
  },
  ch_en: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.just-eat.ch/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'fr',
          url: 'https://www.just-eat.ch/fr/deals/ukraine-donation-terms/',
        },
        {
          logo: 'de',
          url: 'https://www.just-eat.ch/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.ch/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.ch/en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'JUST EAT (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donate.unrefugees.ch/ch/en-ch/JustEat-Ukraine?utm_source=partnerships&utm_medium=partnerships&utm_campaign=CH_PS_EN_UA&utm_content=RF1202651+',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.ch/en/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.ch/en/privacy-statement',
    },
    copyright: '© 2022 Just Eat',
  },
  pl_en: {
    navbar: {
      logo: 'pyszne-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.pyszne.pl/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'pl',
          url: 'https://www.pyszne.pl/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.pyszne.pl/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Pyszne.pl',
      url: 'https://www.pyszne.pl/en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Pyszne.pl (part of Just Eat Takeaway.com group) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donate.unhcr.org/int/en/ukraine-emergency-justeat-pl-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=HQ_PS_EN_UA___poland-justeat-bg-emg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.pyszne.pl/en/info/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.pyszne.pl/en/info/privacy-statement',
    },
    copyright: '© 2022 Pyszne.pl',
  },
  lu_en: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/lu-en/deals/ukraine-donation-terms',
        },
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/lu/deals/ukraine-donation-terms',
        },
        {
          logo: 'de',
          url: 'https://www.takeaway.com/lu-de/deals/ukraine-donation-terms',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/lu-en/',
    },
    title: 'Ukraine Crisis Charity Appeal – Customer Terms and Conditions',
    one: [
      'Takeaway.com (“JET”) and its group companies, are working with the UNHCR, a charity which supports refugees around the world, to raise money to support refugees affected by the ongoing crisis in Ukraine (the “Appeal”). Details of the UNHCR are as follows: ',
      'Name:  UNHCR Nederland',
      'Registration number (RSIN): 82 39 59 636',
      'Registration location: UNHCR Nederland is part of the United Nations, operating in the Netherlands',
      'Address: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'You can make donations to UNHCR by clicking the following ',
      link: 'link',
      url: 'https://donate.unhcr.org/be/fr-be/ukraine-emergency-justeat-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=BE_PS_FR_UA___luxemburg-french-justeat-ctg',
    },
    three:
      'By clicking on the link above, you hereby agree to these terms and conditions.',
    four: 'By clicking on the link above, you will be taken to a webpage controlled by UNHCR. Your access to, and use of the UNHCR website will be subject to the UNHCR’s terms and conditions are set out on their website.',
    five: 'You acknowledge that JET has no control over the content, functionality, security or any other aspect of UNHCR’s website, and JET makes no warranty or representation (whether express or implies) in relation to such website.',
    six: 'You acknowledge that any personal data collected by the UNHCR website will be processed by the UNHCR in accordance with the UNHCR’s privacy notice as made available on their website.',
    seven:
      'For every donation made to UNHCR by a JET customer using the donation mechanism explained above, JET will make a donation to UNHCR of an equal amount up to a global total aggregate maximum value of EUR 500,000 across all participating markets.',
    eight:
      'The Appeal will run from 04.03.2022 to 04.04.2022. JET may extend or shorten the duration of the Appeal at its sole discretion.',
    nine: 'JET reserves the right to unilaterally amend these Terms and Conditions or withdraw the appeal at any time without prior notice, provided that donations made by JET customers prior to such time will continue to be matched subject to the donation limit referred to above.',
    ten: {
      one: 'All standard terms and conditions from time to time for use of ',
      two: ' website and services apply.',
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.takeaway.com/lu-en/terms-of-use',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/lu-en/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  de_de: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'de',
          url: 'https://www.lieferando.de/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.lieferando.de/en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Wir verwenden Cookies und andere Techniken, um Deine Erfahrungen und Anzeigen gemeinsam mit Dritten zu verbessern und zu personalisieren. ',
      url: 'https://www.lieferando.de/cookiestatement',
      url_text: 'Einstellungen verwalten',
      button: 'OK',
    },
    market: {
      name: 'Liferando.de',
      url: 'https://www.lieferando.de/',
    },
    title:
      'Ukraine-Krise Spendenaufruf - Allgemeine Geschäftsbedingungen für Kunden',
    one: [
      'Lieferando ("JET") und seine Konzerngesellschaften arbeiten mit dem UNO-Flüchtlingshilfe zusammen, einer Wohltätigkeitsorganisation, die Flüchtlinge auf der ganzen Welt unterstützt, um Geld für die Unterstützung von Flüchtlingen zu sammeln, die von der anhaltenden Krise in der Ukraine betroffen sind (der "Appell").  Einzelheiten über das UNO-Flüchtlingshilfe sind im Folgenden aufgeführt: ',
      'Name:  UNO-Flüchtlingshilfe',
      'Registrierungsnummer (RSIN): 4539',
      'Anschrift: Graurheindorfer Str. 149 a, 53117 Bonn',
    ],
    two: {
      text: 'Du kannst für das UNO-Flüchtlingshilfe spenden, indem du auf den folgenden Link klickst. ',
      link: 'Link klickst',
      url: 'https://www.uno-fluechtlingshilfe.de/lieferandohilft?donation_custom_field_1628=W-12141&utm[…]do&utm_medium=referral&utm_campaign=DE_PS_DE_APPEAL_UA',
    },
    three:
      'Indem du auf den oben genannten Link klickst, erklärst du dich mit diesen Bedingungen einverstanden.',
    four: 'Durch Anklicken des obigen Links wirst du auf eine vom UNO-Flüchtlingshilfe kontrollierte Webseite weitergeleitet. Ihr Zugriff auf die UNO-Flüchtlingshilfe-Webseite und deren Nutzung unterliegen den auf der Webseite des UNO-Flüchtlingshilfe dargelegten allgemeinen Geschäftsbedingungen.  ',
    five: 'Du erkennst an, dass JET keine Kontrolle über den Inhalt, die Funktionalität, die Sicherheit oder andere Aspekte der UNO-Flüchtlingshilfe-Website hat und dass JET keine Garantie oder Zusicherung (weder ausdrücklich noch stillschweigend) in Bezug auf diese Webseite gibt.',
    six: 'Du erkennst an, dass alle auf der UNO-Flüchtlingshilfe-Webseite erhobenen personenbezogenen Daten vom UNO-Flüchtlingshilfe in Übereinstimmung mit dem auf der UNO-Flüchtlingshilfe-Webseite veröffentlichten Datenschutzhinweis verarbeitet werden.',
    seven:
      'Für jede Spende an das UNO-Flüchtlingshilfe, die ein JET-Kunde über den oben beschriebenen Spendenmechanismus tätigt, spendet JET dem UNO-Flüchtlingshilfe einen Betrag in gleicher Höhe bis zu einem Gesamtwert von 500.000 Euro für alle teilnehmenden Märkte.',
    eight:
      'Der Appell läuft vom 04.03.2022 bis zum 04.04.2022. JET kann die Dauer des Aufrufs nach eigenem Ermessen verlängern oder verkürzen.',
    nine: 'JET behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen einseitig zu ändern oder den Aufruf jederzeit ohne vorherige Ankündigung zurückzuziehen, vorausgesetzt, dass Spenden, die von JET-Kunden vor diesem Zeitpunkt getätigt wurden, weiterhin im Rahmen des oben genannten Spendenlimits verdoppelt werden.',
    ten: {
      one: 'Es gelten die jeweils üblichen Bedingungen für die Nutzung der ',
      two: ' Webseite und der Dienste.',
    },
    conditions: {
      link: 'AGBs',
      url: 'https://www.lieferando.de/agb',
    },
    privacy: {
      link: 'Datenschutzerklärung',
      url: 'https://www.lieferando.de/privacy-statement',
    },
    copyright: '© 2022 Lieferando.de',
  },
  at_de: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'de',
          url: 'https://www.lieferando.at/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.lieferando.at/en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Wir verwenden Cookies und andere Techniken, um Deine Erfahrungen und Anzeigen gemeinsam mit Dritten zu verbessern und zu personalisieren. ',
      url: 'https://www.lieferando.at/cookiestatement',
      url_text: 'Einstellungen verwalten',
      button: 'OK',
    },
    market: {
      name: 'Liferando.de',
      url: 'https://www.lieferando.at/',
    },
    title:
      'Ukraine-Krise Spendenaufruf - Allgemeine Geschäftsbedingungen für Kunden',
    one: [
      'Lieferando (Teil von Just Eat Takeaway.com) und seine Konzerngesellschaften arbeiten mit dem UNHCR zusammen, einer Wohltätigkeitsorganisation, die Flüchtlinge auf der ganzen Welt unterstützt, um Geld für die Unterstützung von Flüchtlingen zu sammeln, die von der anhaltenden Krise in der Ukraine betroffen sind (der "Appell").  Einzelheiten über das UNHCR sind im Folgenden aufgeführt: ',
      'Name:  UNHCR Nederland',
      'Registrierungsnummer (RSIN): 82 39 59 636',
      'Ort der Registrierung: UNHCR Nederland ist Teil der Vereinten Nationen und in den Niederlanden tätig. ',
      'Anschrift: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Du kannst für das UNHCR spenden, indem du auf den folgenden ',
      link: 'Link klickst',
      url: 'https://www.uno-fluechtlingshilfe.de/spenden-ukraine?donation_custom_field_1628=W-12152&utm_source=justeatAT&utm_medium=referral&utm_campaign=DE_PS_DE_APPEAL_UA',
    },
    three:
      'Indem du auf den oben genannten Link klickst, erklärst du dich mit diesen Bedingungen einverstanden.',
    four: 'Durch Anklicken des obigen Links wirst du auf eine vom UNHCR kontrollierte Webseite weitergeleitet. Ihr Zugriff auf die UNHCR-Webseite und deren Nutzung unterliegen den auf der Webseite des UNHCR dargelegten allgemeinen Geschäftsbedingungen.  ',
    five: 'Du erkennst an, dass JET keine Kontrolle über den Inhalt, die Funktionalität, die Sicherheit oder andere Aspekte der UNHCR-Website hat und dass JET keine Garantie oder Zusicherung (weder ausdrücklich noch stillschweigend) in Bezug auf diese Webseite gibt.',
    six: 'Du erkennst an, dass alle auf der UNHCR-Webseite erhobenen personenbezogenen Daten vom UNHCR in Übereinstimmung mit dem auf der UNHCR-Webseite veröffentlichten Datenschutzhinweis verarbeitet werden.',
    seven:
      'Für jede Spende an das UNHCR, die ein JET-Kunde über den oben beschriebenen Spendenmechanismus tätigt, spendet JET dem UNHCR einen Betrag in gleicher Höhe bis zu einem Gesamtwert von 500.000 Euro für alle teilnehmenden Märkte.',
    eight:
      'Der Appell läuft vom 04.03.2022 bis zum 04.04.2022. JET kann die Dauer des Aufrufs nach eigenem Ermessen verlängern oder verkürzen.',
    nine: 'JET behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen einseitig zu ändern oder den Aufruf jederzeit ohne vorherige Ankündigung zurückzuziehen, vorausgesetzt, dass Spenden, die von JET-Kunden vor diesem Zeitpunkt getätigt wurden, weiterhin im Rahmen des oben genannten Spendenlimits verdoppelt werden.',
    ten: {
      one: 'Es gelten die jeweils üblichen Bedingungen für die Nutzung der ',
      two: ' Webseite und der Dienste.',
    },
    conditions: {
      link: 'AGBs',
      url: 'https://www.lieferando.at/agb',
    },
    privacy: {
      link: 'Datenschutzerklärung',
      url: 'https://www.lieferando.at/privacy-statement',
    },
    copyright: '© 2022 Lieferando.at',
  },
  lu_de: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'de',
          url: 'https://www.takeaway.com/lu-de/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/lu-en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Wir verwenden Cookies und andere Techniken, um Deine Erfahrungen und Anzeigen gemeinsam mit Dritten zu verbessern und zu personalisieren. ',
      url: 'https://www.takeaway.com/lu-de/cookiestatement',
      url_text: 'Einstellungen verwalten',
      button: 'OK',
    },
    market: {
      name: 'Liferando.de',
      url: 'https://www.takeaway.com/lu-de/',
    },
    title:
      'Ukraine-Krise Spendenaufruf - Allgemeine Geschäftsbedingungen für Kunden',
    one: [
      'Takeaway.com ("JET") und seine Konzerngesellschaften arbeiten mit dem UNHCR zusammen, einer Wohltätigkeitsorganisation, die Flüchtlinge auf der ganzen Welt unterstützt, um Geld für die Unterstützung von Flüchtlingen zu sammeln, die von der anhaltenden Krise in der Ukraine betroffen sind (der "Appell").  Einzelheiten über das UNHCR sind im Folgenden aufgeführt: ',
      'Name:  UNHCR Nederland',
      'Registrierungsnummer (RSIN): 82 39 59 636',
      'Ort der Registrierung: UNHCR Nederland ist Teil der Vereinten Nationen und in den Niederlanden tätig. ',
      'Anschrift: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Du kannst für das UNHCR spenden, indem du auf den folgenden ',
      link: 'Link klickst',
      url: 'https://donate.unhcr.org/be/en-be/ukraine-emergency-justeat-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=BE_PS_DE_UA___luxemburg-german-justeat-ctg',
    },
    three:
      'Indem du auf den oben genannten Link klickst, erklärst du dich mit diesen Bedingungen einverstanden.',
    four: 'Durch Anklicken des obigen Links wirst du auf eine vom UNHCR kontrollierte Webseite weitergeleitet. Ihr Zugriff auf die UNHCR-Webseite und deren Nutzung unterliegen den auf der Webseite des UNHCR dargelegten allgemeinen Geschäftsbedingungen.  ',
    five: 'Du erkennst an, dass JET keine Kontrolle über den Inhalt, die Funktionalität, die Sicherheit oder andere Aspekte der UNHCR-Website hat und dass JET keine Garantie oder Zusicherung (weder ausdrücklich noch stillschweigend) in Bezug auf diese Webseite gibt.',
    six: 'Du erkennst an, dass alle auf der UNHCR-Webseite erhobenen personenbezogenen Daten vom UNHCR in Übereinstimmung mit dem auf der UNHCR-Webseite veröffentlichten Datenschutzhinweis verarbeitet werden.',
    seven:
      'Für jede Spende an das UNHCR, die ein JET-Kunde über den oben beschriebenen Spendenmechanismus tätigt, spendet JET dem UNHCR einen Betrag in gleicher Höhe bis zu einem Gesamtwert von 500.000 Euro für alle teilnehmenden Märkte.',
    eight:
      'Der Appell läuft vom 04.03.2022 bis zum 04.04.2022. JET kann die Dauer des Aufrufs nach eigenem Ermessen verlängern oder verkürzen.',
    nine: 'JET behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen einseitig zu ändern oder den Aufruf jederzeit ohne vorherige Ankündigung zurückzuziehen, vorausgesetzt, dass Spenden, die von JET-Kunden vor diesem Zeitpunkt getätigt wurden, weiterhin im Rahmen des oben genannten Spendenlimits verdoppelt werden.',
    ten: {
      one: 'Es gelten die jeweils üblichen Bedingungen für die Nutzung der ',
      two: ' Webseite und der Dienste.',
    },
    conditions: {
      link: 'AGBs',
      url: 'https://www.takeaway.com/lu-de/agb',
    },
    privacy: {
      link: 'Datenschutzerklärung',
      url: 'https://www.takeaway.com/lu-de/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  ch_de: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'de',
          url: 'https://www.just-eat.ch/ch-de/deals/ukraine-donation-terms/',
        },
        {
          logo: 'fr',
          url: 'https://www.just-eat.ch/fr/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.ch/en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Wir verwenden Cookies und andere Techniken, um Deine Erfahrungen und Anzeigen gemeinsam mit Dritten zu verbessern und zu personalisieren. ',
      url: 'https://www.just-eat.ch/cookiestatement',
      url_text: 'Einstellungen verwalten',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.ch/ch-de/',
    },
    title:
      'Ukraine-Krise Spendenaufruf - Allgemeine Geschäftsbedingungen für Kunden',
    one: [
      'Just Eat ("JET") und seine Konzerngesellschaften arbeiten mit dem Switzerland for UNHCR zusammen, einer Wohltätigkeitsorganisation, die Flüchtlinge auf der ganzen Welt unterstützt, um Geld für die Unterstützung von Flüchtlingen zu sammeln, die von der anhaltenden Krise in der Ukraine betroffen sind (der "Appell").  Einzelheiten über das Switzerland for UNHCR sind im Folgenden aufgeführt: ',
      'Name:  Switzerland for UNHCR',
      'Foundation CHE-297.811.210',
      'Anschrift: 96 Rue de Montbrillant, Mailbox 2539, 1211 Geneva 2',
    ],
    two: {
      text: 'Du kannst für das Switzerland for UNHCR spenden, indem du auf den folgenden ',
      link: 'Link klickst',
      url: 'https://donate.unrefugees.ch/ch/de-ch/JustEat-Ukraine-de?utm_source=partnerships&utm_medium=partnerships&utm_campaign=CH_PS_DE_UA&utm_content=RF1202651+',
    },
    three:
      'Indem du auf den oben genannten Link klickst, erklärst du dich mit diesen Bedingungen einverstanden.',
    four: 'Durch Anklicken des obigen Links wirst du auf eine vom Switzerland for UNHCR kontrollierte Webseite weitergeleitet. Ihr Zugriff auf die Switzerland for UNHCR-Webseite und deren Nutzung unterliegen den auf der Webseite des Switzerland for UNHCR dargelegten allgemeinen Geschäftsbedingungen.  ',
    five: 'Du erkennst an, dass JET keine Kontrolle über den Inhalt, die Funktionalität, die Sicherheit oder andere Aspekte der Switzerland for UNHCR-Website hat und dass JET keine Garantie oder Zusicherung (weder ausdrücklich noch stillschweigend) in Bezug auf diese Webseite gibt.',
    six: 'Du erkennst an, dass alle auf der Switzerland for UNHCR-Webseite erhobenen personenbezogenen Daten vom Switzerland for UNHCR in Übereinstimmung mit dem auf der Switzerland for UNHCR-Webseite veröffentlichten Datenschutzhinweis verarbeitet werden.',
    seven:
      'Für jede Spende an das Switzerland for UNHCR, die ein JET-Kunde über den oben beschriebenen Spendenmechanismus tätigt, spendet JET dem Switzerland for UNHCR einen Betrag in gleicher Höhe bis zu einem Gesamtwert von 500.000 Euro für alle teilnehmenden Märkte.',
    eight:
      'Der Appell läuft vom 04.03.2022 bis zum 04.04.2022. JET kann die Dauer des Aufrufs nach eigenem Ermessen verlängern oder verkürzen.',
    nine: 'JET behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen einseitig zu ändern oder den Aufruf jederzeit ohne vorherige Ankündigung zurückzuziehen, vorausgesetzt, dass Spenden, die von JET-Kunden vor diesem Zeitpunkt getätigt wurden, weiterhin im Rahmen des oben genannten Spendenlimits verdoppelt werden.',
    ten: {
      one: 'Es gelten die jeweils üblichen Bedingungen für die Nutzung der ',
      two: ' Webseite und der Dienste.',
    },
    conditions: {
      link: 'AGBs',
      url: 'https://www.just-eat.ch/agb',
    },
    privacy: {
      link: 'Datenschutzerklärung',
      url: 'https://www.just-eat.ch/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  es_es: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'es',
          url: 'https://www.just-eat.es/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.co.uk/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.es/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.es',
    },
    title:
      'Llamamiento benéfico por la crisis de Ucrania - Condiciones de uso ',
    one: [
      'JUST-EAT SPAIN S.L.U. (JET) y las empresas de su grupo, están colaborando con ACNUR en España, una organización benéfica que apoya a los refugiados en todo el mundo, para recaudar dinero para apoyar a los refugiados afectados por la crisis actual en Ucrania (el "Llamamiento").  Los datos del ACNUR en España son los siguientes: ',
      'Nombre:  ACNUR en España',
      'Número de registro (RSIN): G80757560',
      'Dirección: C. de Cedaceros, 11, 28014 Madrid',
    ],
    two: {
      text: 'Puedes hacer donaciones a ACNUR en España haciendo clic en el siguiente ',
      link: 'enlace',
      url: 'https://eacnur.org/es/crisis-en-ucrania-justeat?utm_source=partnerships&utm_medium=partnerships&utm_campaign=ES_PS_ES_UA___justeat-ctg',
    },
    three:
      'Al hacer clic en el enlace anterior, usted acepta estos términos y condiciones.',
    four: 'Al hacer clic en el enlace anterior, accederá a una página web controlada por el ACNUR en España.  Su acceso y uso del sitio web del ACNUR está sujeto a los términos y condiciones de ACNUR en España que se establecen en su sitio web.',
    five: 'Usted reconoce que JET no tiene ningún control sobre el contenido, la funcionalidad, la seguridad o cualquier otro aspecto del sitio web de ACNUR en España, y que JET no ofrece ninguna garantía ni representación (ya sea expresa o implícita) en relación con dicho sitio web.',
    six: 'Usted reconoce que cualquier dato personal recogido por el sitio web de ACNUR en España será procesado por ACNUR en España de acuerdo con el aviso de privacidad de ACNUR en España disponible en su sitio web.',
    seven:
      'Por cada donación realizada a ACNUR en España por un cliente de JET utilizando el mecanismo de donación explicado anteriormente, JET realizará una donación a ACNUR en España por un importe igual hasta un valor máximo total global de 500.000 euros en todos los mercados participantes.',
    eight:
      'El llamamiento estará vigente desde el 04.03.2022 hasta el 04.04.2022. JET podrá ampliar o acortar la duración del Llamamiento a su entera discreción.',
    nine: 'JET se reserva el derecho de modificar unilateralmente estos Términos y Condiciones o de retirar el llamamiento en cualquier momento sin previo aviso, siempre que las donaciones realizadas por los clientes de JET antes de ese momento sigan siendo igualadas con sujeción al límite de donaciones mencionado anteriormente.',
    ten: {
      one: 'Se aplicarán todos los términos y condiciones habituales de uso del sitio web y los servicios de Just-eat.es.',
      two: '',
    },
    conditions: {
      link: 'Términos y condiciones',
      url: 'https://www.just-eat.es/info/terminos-y-condiciones',
    },
    privacy: {
      link: 'Política de privacidad',
      url: 'https://www.just-eat.es/info/politica-de-privacidad',
    },
    copyright: '© 2022 Just Eat',
  },
  it_it: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: '',
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.it/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.it',
    },
    title: `Appello di beneficenza per la crisi dell'Ucraina - Termini e condizioni del cliente`,
    one: [
      `Just Eat Italy S.r.l.  ("JET") e le società del suo gruppo stanno collaborando con l'UNHCR, un ente di beneficenza che sostiene i rifugiati in tutto il mondo, per raccogliere fondi a sostegno dei rifugiati colpiti dalla crisi in corso in Ucraina (l'"Appello").  I dettagli dell'UNHCR sono i seguenti:`,
      'Nome:  UNHCR Nederland',
      'Numero di registrazione (RSIN): 82 39 59 636',
      'Luogo di registrazione: UNHCR Nederland fa parte delle Nazioni Unite e opera nei Paesi Bassi',
      'Indirizzo: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: `Puoi fare donazioni all'UNHCR cliccando sul seguente `,
      link: 'link',
      url: 'https://dona.unhcr.it/campagna/emergenza-ucraina-justeat/?cmp=22_OB_03_22&utm_source=partnerships&utm_medium=partnerships&utm_campaign=IT_PS_IT_UA___justeat-ctg',
    },
    three:
      'Cliccando sul link di cui sopra, accetti questi termini e condizioni.',
    four: `Cliccando sul link di cui sopra, sarete indirizzati ad una pagina web controllata dall'UNHCR.  L'accesso e l'uso del sito web dell'UNHCR saranno soggetti ai termini e alle condizioni dell'UNHCR riportati sul loro sito web.`,
    five: `Riconoscete che JET non ha alcun controllo sul contenuto, la funzionalità, la sicurezza o qualsiasi altro aspetto del sito web dell'UNHCR, e JET non fornisce alcuna garanzia o dichiarazione (sia espressa che implicita) in relazione a tale sito web.`,
    six: `L'utente riconosce che tutti i dati personali raccolti dal sito web dell'UNHCR saranno trattati dall'UNHCR in conformità con l'avviso sulla privacy dell'UNHCR come reso disponibile sul loro sito web.`,
    seven: `Per ogni donazione fatta all'UNHCR da un cliente JET utilizzando il meccanismo di donazione spiegato sopra, JET farà una donazione all'UNHCR di pari importo fino a un valore massimo aggregato globale di EUR 500.000 in tutti i mercati partecipanti.`,
    eight: `L'appello durerà dal 04.03.2022 al 04.04.2022. JET può estendere o ridurre la durata dell'Appello a sua esclusiva discrezione.`,
    nine: `JET si riserva il diritto di modificare unilateralmente i presenti Termini e condizioni o di ritirare l'appello in qualsiasi momento senza preavviso, fermo restando che le donazioni effettuate dai clienti JET prima di tale momento continueranno a essere abbinate nel rispetto del limite di donazione di cui sopra.`,
    ten: {
      one: `Si applicano tutti i termini e le condizioni standard di volta in volta per l'uso del sito web e dei servizi di `,
      two: '',
    },
    conditions: {
      link: 'Termini e condizioni',
      url: 'https://www.justeat.it/informazioni/termini-e-condizioni',
    },
    privacy: {
      link: 'Privacy policy',
      url: 'https://www.justeat.it/informazioni/privacy-policy',
    },
    copyright: '© 2022 Just Eat',
  },
  fr_fr: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'fr',
          url: 'https://www.just-eat.fr/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.fr/en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Nous utilisons les cookies et autres technologies pour améliorer et personnaliser votre expérience d’utilisation, ainsi que des publicités en partenariat avec des tiers.',
      url: 'https://www.just-eat.fr/cookiestatement',
      url_text: 'Gérer vos préférences',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.fr',
    },
    title: 'Ukraine Crisis Charity Appeal - Conditions générales de vente',
    one: [
      `Just Eat [JET] et les sociétés de son groupe travaillent avec le UNHCR , une organisation caritative qui soutient les réfugiés dans le monde entier, afin de collecter des fonds pour aider les réfugiés touchés par la crise actuelle en Ukraine (l'"appel").  Les détails de l'UNHCR sont les suivants : `,
      'Nom :  UNHCR Nederland',
      `Numéro d'enregistrement (RSIN) : 82 39 59 636`,
      `Lieu d'enregistrement : Le UNHCR Nederland fait partie des Nations Unies et opère aux Pays-Bas. `,
      'Adresse : Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Vous pouvez faire des dons au UNHCR en cliquant sur le lien ',
      link: 'suivant',
      url: 'https://donner.unhcr.org/urgence-ukraine-justeat/?utm_source=partnerships&utm_medium=partnerships&utm_campaign=FR_PS_FR_UA___justeat-ctg',
    },
    three:
      'En cliquant sur le lien ci-dessus, vous acceptez les présentes conditions générales.',
    four: `En cliquant sur le lien ci-dessus, vous accédez à une page web contrôlée par le UNHCR.  L'accès au site Web du UNHCR et son utilisation sont soumis aux conditions générales du UNHCR énoncées sur son site Web.  `,
    five: `Vous reconnaissez que le JET n'a aucun contrôle sur le contenu, la fonctionnalité, la sécurité ou tout autre aspect du site Web du UNHCR, et le JET ne donne aucune garantie ou représentation (expresse ou implicite) en relation avec ce site Web.`,
    six: `Vous reconnaissez que toute donnée personnelle recueillie par le site web du UNHCR sera traitée par le UNHCR conformément à l'avis de confidentialité du UNHCR tel que disponible sur son site web.`,
    seven: `Pour chaque don fait au UNHCR par un client de JET en utilisant le mécanisme de don expliqué ci-dessus, JET fera un don au UNHCR d'un montant égal jusqu'à une valeur maximale globale totale de 500,000 d'euros sur tous les marchés participants.`,
    eight: `L'appel se déroulera du 04.03.2022 au 04.04.2022. Le JET peut prolonger ou raccourcir la durée de l'Appel à sa seule discrétion.`,
    nine: `JET se reserva el derecho de modificar unilateralmente estos Términos y Condiciones o de retirar el llamamiento en cualquier momento sin previo aviso, siempre que las donaciones realizadas por los clientes de JET antes de ese momento sigan siendo igualadas con sujeción al límite de donaciones mencionado anteriormente. `,
    ten: {
      one: `Toutes les conditions générales d'utilisation du site Web et des services de `,
      two: ` s'appliquent. `,
    },
    conditions: {
      link: 'Conditions Générales',
      url: 'https://www.just-eat.fr/conditions-d-utilisation',
    },
    privacy: {
      link: 'Déclaration de confidentialité',
      url: 'https://www.just-eat.fr/privacy-statement',
    },
    copyright: '© 2022 Just Eat',
  },
  ch_fr: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'fr',
          url: 'https://www.just-eat.ch/fr/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.ch/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'de',
          url: 'https://www.just-eat.ch/de/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Nous utilisons les cookies et autres technologies pour améliorer et personnaliser votre expérience d’utilisation, ainsi que des publicités en partenariat avec des tiers.',
      url: 'https://www.just-eat.ch/cookiestatement',
      url_text: 'Gérer vos préférences',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.ch/fr',
    },
    title: 'Ukraine Crisis Charity Appeal - Conditions générales de vente',
    one: [
      `Just Eat [JET] et les sociétés de son groupe travaillent avec le Switzerland for UNHCR, une organisation caritative qui soutient les réfugiés dans le monde entier, afin de collecter des fonds pour aider les réfugiés touchés par la crise actuelle en Ukraine (l'"appel").  Les détails de l'Switzerland for UNHCR sont les suivants : `,
      'Nom :  Switzerland for UNHCR',
      `Foundation CHE-297.811.210`,
      `Adresse : 96 Rue de Montbrillant, Mailbox 2539, 1211 Geneva 2`,
    ],
    two: {
      text: 'Vous pouvez faire des dons au Switzerland for UNHCR en cliquant sur le lien ',
      link: 'suivant',
      url: 'https://donate.unrefugees.ch/ch/fr-ch/JustEat-Ukraine-fr?utm_source=donate.unhcr.org&utm_medium=referral&utm_campaign=CH_PS_FR_UA&utm_content=RF1202651+',
    },
    three:
      'En cliquant sur le lien ci-dessus, vous acceptez les présentes conditions générales.',
    four: `En cliquant sur le lien ci-dessus, vous accédez à une page web contrôlée par le Switzerland for UNHCR.  L'accès au site Web du Switzerland for UNHCR et son utilisation sont soumis aux conditions générales du Switzerland for UNHCR énoncées sur son site Web.  `,
    five: `Vous reconnaissez que le JET n'a aucun contrôle sur le contenu, la fonctionnalité, la sécurité ou tout autre aspect du site Web du Switzerland for UNHCR, et le JET ne donne aucune garantie ou représentation (expresse ou implicite) en relation avec ce site Web.`,
    six: `Vous reconnaissez que toute donnée personnelle recueillie par le site web du Switzerland for UNHCR sera traitée par le Switzerland for UNHCR conformément à l'avis de confidentialité du Switzerland for UNHCR tel que disponible sur son site web.`,
    seven: `Pour chaque don fait au Switzerland for UNHCR par un client de JET en utilisant le mécanisme de don expliqué ci-dessus, JET fera un don au Switzerland for UNHCR d'un montant égal jusqu'à une valeur maximale globale totale de 500,000 d'euros sur tous les marchés participants.`,
    eight: `L'appel se déroulera du 04.03.2022 au 04.04.2022. Le JET peut prolonger ou raccourcir la durée de l'Appel à sa seule discrétion.`,
    nine: `JET se réserve le droit de modifier unilatéralement les présentes conditions générales ou de retirer l'appel à tout moment sans préavis, à condition que les dons effectués par les clients de JET avant ce moment continuent d'être jumelés sous réserve de la limite de dons mentionnée ci-dessus.`,
    ten: {
      one: `Toutes les conditions générales d'utilisation du site Web et des services de `,
      two: ` s'appliquent. `,
    },
    conditions: {
      link: 'Conditions Générales',
      url: 'https://www.just-eat.ch/fr/conditions-d-utilisation',
    },
    privacy: {
      link: 'Déclaration de confidentialité',
      url: 'https://www.just-eat.ch/fr/privacy-statement',
    },
    copyright: '© 2022 Just Eat',
  },
  lu_fr: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/lu/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/lu-en/eals/ukraine-donation-terms/',
        },
        {
          logo: 'de',
          url: 'https://www.takeaway.com/lu-de/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Nous utilisons les cookies et autres technologies pour améliorer et personnaliser votre expérience d’utilisation, ainsi que des publicités en partenariat avec des tiers.',
      url: 'https://www.takeaway.com/lu/cookiestatement',
      url_text: 'Gérer vos préférences',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/lu/',
    },
    title: 'Ukraine Crisis Charity Appeal - Conditions générales de vente',
    one: [
      `Takeaway.com [JET] et les sociétés de son groupe travaillent avec le HCR, une organisation caritative qui soutient les réfugiés dans le monde entier, afin de collecter des fonds pour aider les réfugiés touchés par la crise actuelle en Ukraine (l'"appel").  Les détails de l'UNHCR sont les suivants : `,
      'Nom :  UNHCR Nederland',
      `Numéro d'enregistrement (RSIN) : 82 39 59 636`,
      `Lieu d'enregistrement : Le UNHCR Nederland fait partie des Nations Unies et opère aux Pays-Bas. `,
      'Adresse : Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Vous pouvez faire des dons au UNHCR en cliquant sur le lien ',
      link: 'suivant',
      url: 'https://donate.unhcr.org/be/fr-be/ukraine-emergency-justeat-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=BE_PS_FR_UA___luxemburg-french-justeat-ctg',
    },
    three:
      'En cliquant sur le lien ci-dessus, vous acceptez les présentes conditions générales.',
    four: `En cliquant sur le lien ci-dessus, vous accédez à une page web contrôlée par le UNHCR.  L'accès au site Web du UNHCR et son utilisation sont soumis aux conditions générales du UNHCR énoncées sur son site Web.`,
    five: `Vous reconnaissez que le JET n'a aucun contrôle sur le contenu, la fonctionnalité, la sécurité ou tout autre aspect du site Web du UNHCR, et le JET ne donne aucune garantie ou représentation (expresse ou implicite) en relation avec ce site Web.`,
    six: `Vous reconnaissez que toute donnée personnelle recueillie par le site web du UNHCR sera traitée par le UNHCR conformément à l'avis de confidentialité du UNHCR tel que disponible sur son site web.`,
    seven: `Pour chaque don fait au UNHCR par un client de JET en utilisant le mécanisme de don expliqué ci-dessus, JET fera un don au UNHCR d'un montant égal jusqu'à une valeur maximale globale totale de 500 000 d'euros sur tous les marchés participants.`,
    eight: `L'appel se déroulera du 04.03.2022 au 04.04.2022. Le JET peut prolonger ou raccourcir la durée de l'Appel à sa seule discrétion.`,
    nine: `JET se réserve le droit de modifier unilatéralement les présentes conditions générales ou de retirer l'appel à tout moment sans préavis, à condition que les dons effectués par les clients de JET avant ce moment continuent d'être jumelés sous réserve de la limite de dons mentionnée ci-dessus.`,
    ten: {
      one: `Toutes les conditions générales d'utilisation du site Web et des services de `,
      two: ` s'appliquent. `,
    },
    conditions: {
      link: 'Conditions Générales',
      url: 'https://www.takeaway.com/lu-fr/terms-of-use',
    },
    privacy: {
      link: 'Déclaration de confidentialité',
      url: 'https://www.takeaway.com/lu-fr/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  be_fr: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/be-fr/deals/ukraine-donation-terms/',
        },
        {
          logo: 'nl',
          url: 'https://www.takeaway.com/be/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/be-en/eals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Nous utilisons les cookies et autres technologies pour améliorer et personnaliser votre expérience d’utilisation, ainsi que des publicités en partenariat avec des tiers.',
      url: 'https://www.takeaway.com/be-fr/cookiestatement',
      url_text: 'Gérer vos préférences',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/be-fr',
    },
    title: 'Ukraine Crisis Charity Appeal - Conditions générales de vente',
    one: [
      `Takeaway.com [JET] et les sociétés de son groupe travaillent avec le UNHCR , une organisation caritative qui soutient les réfugiés dans le monde entier, afin de collecter des fonds pour aider les réfugiés touchés par la crise actuelle en Ukraine (l'"appel").  Les détails de l'UNHCR sont les suivants : `,
      'Nom :  UNHCR Nederland',
      `Numéro d'enregistrement (RSIN) : 82 39 59 636`,
      `Lieu d'enregistrement : Le UNHCR Nederland fait partie des Nations Unies et opère aux Pays-Bas. `,
      'Adresse : Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Vous pouvez faire des dons au UNHCR en cliquant sur le lien ',
      link: 'suivant',
      url: 'https://donate.unhcr.org/be/fr-be/ukraine-emergency-justeat-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=BE_PS_FR_UA___belgium-french-justeat-ctg',
    },
    three:
      'En cliquant sur le lien ci-dessus, vous acceptez les présentes conditions générales.',
    four: `En cliquant sur le lien ci-dessus, vous accédez à une page web contrôlée par le UNHCR.  L'accès au site Web du UNHCR et son utilisation sont soumis aux conditions générales du UNHCR énoncées sur son site Web.  `,
    five: `Usted reconoce que JET no tiene ningún control sobre el contenido, la funcionalidad, la seguridad o cualquier otro aspecto del sitio web de UNHCR, y que JET no ofrece ninguna garantía ni representación (ya sea expresa o implícita) en relación con dicho sitio web.`,
    six: `Vous reconnaissez que toute donnée personnelle recueillie par le site web du UNHCR sera traitée par le UNHCR conformément à l'avis de confidentialité du UNHCR tel que disponible sur son site web.`,
    seven: `Por cada donación realizada a UNHCR por un cliente de JET utilizando el mecanismo de donación explicado anteriormente, JET realizará una donación a UNHCR por un importe igual hasta un valor máximo total global de 500.000 de euros en todos los mercados participantes.`,
    eight: `El llamamiento estará vigente desde el 04.03.2022 hasta el 04.04.2022. JET podrá ampliar o acortar la duración del Llamamiento a su entera discreción.`,
    nine: `JET se reserva el derecho de modificar unilateralmente estos Términos y Condiciones o de retirar el llamamiento en cualquier momento sin previo aviso, siempre que las donaciones realizadas por los clientes de JET antes de ese momento sigan siendo igualadas con sujeción al límite de donaciones mencionado anteriormente. `,
    ten: {
      one: `Toutes les conditions générales d'utilisation du site Web et des services de `,
      two: ` s'appliquent. `,
    },
    conditions: {
      link: 'Conditions Générales',
      url: 'https://www.takeaway.com/be-fr/terms-of-use',
    },
    privacy: {
      link: 'Déclaration de confidentialité',
      url: 'https://www.takeaway.com/be-fr/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  bg_bg: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'bg',
          url: 'https://www.takeaway.com/bg/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/bg-en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/bg-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/bg/',
    },
    title:
      'Призив за благотворителност при кризата в Украйна - Условия за ползване',
    one: [
      'Takeaway.com ("JET") и дружествата от неговата група работят съвместно с UNHCR, благотворителна организация, която подкрепя бежанците по целия свят, за набиране на средства в подкрепа на бежанците, засегнати от продължаващата криза в Украйна ("Призивът").  Подробна информация за UNHCR е следната: ',
      'Име:  UNHCR Nederland',
      'Регистрационен номер (RSIN): 82 39 59 636',
      'Място на регистрация: UNHCR Nederland е част от Организацията на обединените нации и работи в Нидерландия ',
      'Адрес: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Можете да направите дарения за UNHCR, като кликнете върху следния ',
      link: 'линк',
      url: 'https://donate.unhcr.org/int/en/ukraine-emergency-justeat-bg-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=HQ_PS_EN_UA___bulgaria-justeat-bg-emg',
    },
    three:
      'С натискането на горепосочената връзка се съгласявате с настоящите правила и условия.',
    four: 'Като кликнете върху връзката по-горе, ще бъдете прехвърлени на уебстраница, контролирана от UNHCR.  Вашият достъп до и използването на уебсайта на UNHCR ще бъде предмет на правилата и условията на UNHCR, които са изложени на техния уебсайт.',
    five: 'Вие потвърждавате, че JET няма контрол върху съдържанието, функционалността, сигурността или друг аспект на уебсайта на UNHCR и JET не дава никакви гаранции или изявления (изрични или подразбиращи се) във връзка с този уебсайт.',
    six: 'Вие потвърждавате, че всички лични данни, събрани от уебсайта на UNHCR, ще бъдат обработвани от UNHCR в съответствие с известието за поверителност на UNHCR, както е публикувано на техния уебсайт.',
    seven:
      'За всяко дарение, направено на UNHCR от клиент на JET чрез механизма за дарения, обяснен по-горе, JET ще направи дарение на UNHCR в същия размер до глобална обща агрегирана максимална стойност от 500,000 EUR на всички участващи пазари.',
    eight:
      'Призивът ще продължи от 04.03.2022 г. до 04.04.2022 г. JET може да удължи или съкрати продължителността на Призива по своя преценка.',
    nine: 'JET си запазва правото едностранно да измени настоящите Общи условия или да оттегли призива по всяко време без предварително уведомление, при условие че даренията, направени от клиенти на JET преди този момент, ще продължат да бъдат съчетавани при спазване на посочения по-горе лимит на даренията.',
    ten: {
      one: 'Прилагат се всички стандартни периодични условия за използване на уебсайта и услугите на ',
      two: ' ',
    },
    conditions: {
      link: 'Условия',
      url: 'https://www.takeaway.com/bg/uslovia-na-polzvane',
    },
    privacy: {
      link: 'Декларация за поверителност',
      url: 'https://www.takeaway.com/bg/politika-za-poveritelnost',
    },
    copyright: '© 2022 Takeaway.com',
  },
  dk_dk: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'dk',
          url: 'https://www.just-eat.dk/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.dk/en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.dk/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Just Eat',
      url: 'https://www.just-eat.dk',
    },
    title: 'Ukraine Crisis Charity Appeal - Kundevilkår og betingelser',
    one: [
      'Just Eat Takeaway.com og dets koncernselskaber samarbejder med UNHCR, en velgørende organisation, der støtter flygtninge i hele verden, om at indsamle penge til støtte for flygtninge, der er berørt af den igangværende krise i Ukraine ("appellen").  Nærmere oplysninger om UNHCR er som følger: ',
      'Navn: UNHCR Nederland',
      'Registreringsnummer (RSIN): 82 39 59 636',
      'Registreringssted: UNHCR Nederland er en del af De Forenede Nationer og opererer i Nederlandene ',
      'Adresse: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Du kan give et bidrag til UNHCR ved at klikke på følgende ',
      link: 'link',
      url: 'https://stoet.unhcr.org/dk/da/ukraine-justeat?utm_source=partnerships&utm_medium=partnerships&utm_campaign=DK_PS_DA_UA___justeat-ctg',
    },
    three:
      'Ved at klikke på ovenstående link accepterer du hermed disse vilkår og betingelser.',
    four: `Ved at klikke på ovenstående link kommer du til en webside, der kontrolleres af UNHCR.  Din adgang til og brug af UNHCR's websted er underlagt UNHCR's vilkår og betingelser, der er fastsat på deres websted.`,
    five: `Du anerkender, at JET ikke har nogen kontrol over indholdet, funktionaliteten, sikkerheden eller andre aspekter af UNHCR's websted, og JET giver ingen garanti eller erklæring (hverken udtrykkeligt eller stiltiende) i forbindelse med et sådant websted.`,
    six: `Du anerkender, at alle personlige oplysninger, der indsamles af UNHCR's websted, vil blive behandlet af UNHCR i overensstemmelse med UNHCR's meddelelse om beskyttelse af personlige oplysninger, som er tilgængelig på deres websted.`,
    seven: `For hver donation, der foretages til UNHCR af en JET-kunde ved hjælp af den donationsmekanisme, der er forklaret ovenfor, vil JET foretage en donation til UNHCR på et tilsvarende beløb op til en global samlet samlet maksimal værdi på 500.000 EUR på tværs af alle deltagende markeder.`,
    eight:
      'Appellen løber fra 04.03.2022 til 04.04.2022. JET kan efter eget skøn forlænge eller forkorte appellens varighed.',
    nine: 'JET forbeholder sig ret til ensidigt at ændre disse vilkår og betingelser eller trække appellen tilbage til enhver tid uden forudgående varsel, forudsat at donationer, der er foretaget af JET-kunder før dette tidspunkt, fortsat vil blive matchet med forbehold af den ovenfor nævnte donationsgrænse.',
    ten: {
      one: 'Alle standardvilkår og -betingelser fra tid til anden for brug af ',
      two: ' web, app og tjenester gælder.',
    },
    conditions: {
      link: 'Vilkår & Betingelser',
      url: 'https://www.just-eat.dk/vilkar-og-betingelser',
    },
    privacy: {
      link: 'Privatlivserklæring',
      url: 'https://www.just-eat.dk/privatlivspolitikt',
    },
    copyright: '© 2022 Just Eat',
  },
  nl_nl: {
    navbar: {
      logo: 'thuisbezorgd-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.thuisbezorgd.nl/en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'nl',
          url: 'https://www.thuisbezorgd.nl/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.thuisbezorgd.nl/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Thuisbezorgd.com',
      url: 'https://www.thuisbezorgd.nl/en/',
    },
    title: 'Oekraïne Crisis Charity Appeal - Algemene Voorwaarden',
    one: [
      'Thuisbezorgd.com ("JET") en zijn groepsmaatschappijen werken samen met de UNHCR, een liefdadigheidsinstelling die vluchtelingen over de hele wereld steunt, om geld in te zamelen ter ondersteuning van vluchtelingen die getroffen worden door de aanhoudende crisis in Oekraïne (de "oproep").  De details van de UNHCR zijn als volgt: ',
      'Naam:  UNHCR Nederland',
      'Registratienummer (RSIN): 82 39 59 636',
      'Registratieplaats: UNHCR Nederland is onderdeel van de Verenigde Naties en opereert in Nederland ',
      'Adres: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'U kunt donaties doen aan UNHCR door op de volgende ',
      link: 'link te klikken',
      url: 'https://doneer.unhcr.nl/oekraine-t',
    },
    three:
      'Door op bovenstaande link te klikken, gaat u akkoord met deze algemene voorwaarden.',
    four: 'Door op de bovenstaande link te klikken, komt u op een webpagina die wordt beheerd door UNHCR.  Uw toegang tot, en gebruik van de UNHCR-website zal onderworpen zijn aan de voorwaarden van de UNHCR die op hun website staan vermeld.  ',
    five: 'U erkent dat JET geen controle heeft over de inhoud, functionaliteit, beveiliging of enig ander aspect van de website van UNHCR, en JET geeft geen garantie of verklaring (expliciet of impliciet) met betrekking tot dergelijke website.',
    six: 'U erkent dat alle persoonsgegevens die door de UNHCR-website worden verzameld, door de UNHCR zullen worden verwerkt in overeenstemming met de privacyverklaring van de UNHCR zoals beschikbaar gesteld op hun website.',
    seven:
      'Voor elke donatie aan UNHCR door een JET-klant met behulp van het donatiemechanisme dat hierboven wordt uitgelegd, zal JET een donatie doen aan UNHCR van een gelijk bedrag tot een wereldwijde totale geaggregeerde maximumwaarde van EUR 500.000 over alle deelnemende markten.',
    eight:
      'De oproep loopt van 04.03.2022 tot 04.04.2022. JET kan de duur van de oproep naar eigen goeddunken verlengen of inkorten.',
    nine: 'JET behoudt zich het recht voor om deze Voorwaarden eenzijdig te wijzigen of de oproep op elk moment zonder voorafgaande kennisgeving in te trekken, met dien verstande dat donaties die door JET-klanten vóór dat moment zijn gedaan, gematcht blijven worden met inachtneming van de hierboven genoemde donatielimiet.',
    ten: {
      one: 'Alle standaardvoorwaarden die van tijd tot tijd gelden voor het gebruik van de website en diensten van ',
      two: ' zijn van toepassing. ',
    },
    conditions: {
      link: 'Algemene voorwaarden',
      url: 'https://www.thuisbezorgd.nl/algemene-voorwaarden',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.thuisbezorgd.nl/privacy-statement',
    },
    copyright: '© 2022 Thuisbezorgd',
  },
  be_nl: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'nl',
          url: 'https://www.takeaway.com/be/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/be-en/deals/ukraine-donation-terms/',
        },
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/be-fr/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/be/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/be/',
    },
    title: 'Oekraïne Crisis Charity Appeal - Algemene Voorwaarden',
    one: [
      'Takeaway.com ("JET") en zijn groepsmaatschappijen werken samen met de UNHCR, een liefdadigheidsinstelling die vluchtelingen over de hele wereld steunt, om geld in te zamelen ter ondersteuning van vluchtelingen die getroffen worden door de aanhoudende crisis in Oekraïne (de "oproep").  De details van de UNHCR zijn als volgt: ',
      'Naam:  UNHCR Nederland',
      'Registratienummer (RSIN): 82 39 59 636',
      'Registratieplaats: UNHCR Nederland is onderdeel van de Verenigde Naties en opereert in Nederland ',
      'Adres: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'U kunt donaties doen aan UNHCR door op de volgende ',
      link: 'link te klikken',
      url: 'https://donate.unhcr.org/be/nl-be/ukraine-emergency-justeat-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=BE_PS_NL_UA___belgium-dutch-justeat-ctg',
    },
    three:
      'Door op bovenstaande link te klikken, gaat u akkoord met deze algemene voorwaarden.',
    four: 'Door op de bovenstaande link te klikken, komt u op een webpagina die wordt beheerd door UNHCR.  Uw toegang tot, en gebruik van de UNHCR-website zal onderworpen zijn aan de voorwaarden van de UNHCR die op hun website staan vermeld.  ',
    five: 'U erkent dat JET geen controle heeft over de inhoud, functionaliteit, beveiliging of enig ander aspect van de website van UNHCR, en JET geeft geen garantie of verklaring (expliciet of impliciet) met betrekking tot dergelijke website.',
    six: 'U erkent dat alle persoonsgegevens die door de UNHCR-website worden verzameld, door de UNHCR zullen worden verwerkt in overeenstemming met de privacyverklaring van de UNHCR zoals beschikbaar gesteld op hun website.',
    seven:
      'Voor elke donatie aan UNHCR door een JET-klant met behulp van het donatiemechanisme dat hierboven wordt uitgelegd, zal JET een donatie doen aan UNHCR van een gelijk bedrag tot een wereldwijde totale geaggregeerde maximumwaarde van EUR 500.000 over alle deelnemende markten.',
    eight:
      'De oproep loopt van 04.03.2022 tot 04.04.2022. JET kan de duur van de oproep naar eigen goeddunken verlengen of inkorten.',
    nine: 'JET behoudt zich het recht voor om deze Voorwaarden eenzijdig te wijzigen of de oproep op elk moment zonder voorafgaande kennisgeving in te trekken, met dien verstande dat donaties die door JET-klanten vóór dat moment zijn gedaan, gematcht blijven worden met inachtneming van de hierboven genoemde donatielimiet.',
    ten: {
      one: 'Alle standaardvoorwaarden die van tijd tot tijd gelden voor het gebruik van de website en diensten van ',
      two: ' zijn van toepassing. ',
    },
    conditions: {
      link: 'Algemene voorwaarden',
      url: 'https://www.takeaway.com/be/algemene-voorwaarden',
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/be/privacy-statement',
    },
    copyright: '© 2022 Takeaway.com',
  },
  pl_pl: {
    navbar: {
      logo: 'pyszne-logo',
      country_toggle: [
        {
          logo: 'pl',
          url: 'https://www.pyszne.pl/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.pyszne.pl/en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'Korzystamy z plików cookie i innych technologii, które pozwalają nam na podnoszenie jakości świadczonych usług i dostarczanych informacji, a także umożliwiają spersonalizowane przygotowywanie treści i reklam wspólnie ze stronami trzecimi.',
      url: 'https://www.pyszne.pl/polityka-cookies',
      url_text: 'Ustawienia',
      button: 'OK',
    },
    market: {
      name: 'Pyszne.pl',
      url: 'https://www.pyszne.pl/',
    },
    title:
      'Akcja charytatywna w związku z kryzysem w Ukrainie - Regulamin klienta',
    one: [
      'Pyszne.pl (część grupy Just Eat Takeaway.com) oraz spółki należące do jego grupy współpracują z UNHCR, organizacją charytatywną wspierającą uchodźców na całym świecie, w celu zebrania funduszy na pomoc uchodźcom dotkniętym trwającym kryzysem w Ukrainie ("Akcja").  Szczegóły dotyczące UNHCR są następujące: ',
      'Nazwa:  UNHCR Nederland',
      'Numer rejestracyjny (RSIN): 82 39 59 636',
      'Miejsce rejestracji: UNHCR Nederland jest częścią Organizacji Narodów Zjednoczonych, działającą w Holandii. ',
      'Adres: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Możesz przekazać darowiznę na rzecz UNHCR, klikając poniższy ',
      link: 'link',
      url: 'https://donate.unhcr.org/int/en/ukraine-emergency-justeat-pl-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=HQ_PS_EN_UA___poland-justeat-bg-emg',
    },
    three: 'Klikając na powyższy link, zgadzasz się na niniejsze warunki.',
    four: 'Klikając na powyższy link, zostaniesz przeniesiony na stronę internetową kontrolowaną przez UNHCR.  Państwa dostęp do strony UNHCR i korzystanie z niej będzie podlegało warunkom określonym na stronie internetowej UNHCR.',
    five: 'Użytkownik przyjmuje do wiadomości, że JET nie ma kontroli nad treścią, funkcjonalnością, bezpieczeństwem ani żadnym innym aspektem strony internetowej UNHCR, a JET nie udziela żadnych gwarancji ani nie składa żadnych oświadczeń (wyraźnych ani dorozumianych) w odniesieniu do tej strony.',
    six: 'Użytkownik przyjmuje do wiadomości, że wszelkie dane osobowe zgromadzone na stronie internetowej UNHCR będą przetwarzane przez UNHCR zgodnie z informacją o ochronie prywatności UNHCR udostępnioną na jego stronie internetowej.',
    seven:
      'Za każdą darowiznę przekazaną na rzecz UNHCR przez klienta JET przy użyciu mechanizmu darowizn opisanego powyżej, JET przekaże na rzecz UNHCR darowiznę w takiej samej wysokości do globalnej łącznej maksymalnej wartości 500,000 EUR na wszystkich uczestniczących rynkach.',
    eight:
      'Akcja będzie trwać od 04.03.2022 do 04.04.2022. JET może przedłużyć lub skrócić czas trwania Kwesty według własnego uznania.',
    nine: 'JET zastrzega sobie prawo do jednostronnej zmiany niniejszego Regulaminu lub wycofania akcji w dowolnym momencie bez wcześniejszego powiadomienia, z zastrzeżeniem, że darowizny przekazane przez klientów JET przed tym terminem będą nadal dopasowywane, z zastrzeżeniem limitu darowizn, o którym mowa powyżej.',
    ten: {
      one: 'Obowiązują wszystkie standardowe warunki korzystania z witryny internetowej i usług ',
      two: ' które są okresowo aktualizowane.',
    },
    conditions: {
      link: 'Regulamin',
      url: 'https://www.pyszne.pl/regulamin',
    },
    privacy: {
      link: 'Polityka prywatności',
      url: 'https://www.pyszne.pl/polityka-prywatnosci',
    },
    copyright: '© 2022 Takeaway.com',
  },
  ro_ro: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'ro',
          url: 'https://www.takeaway.com/ro/deals/ukraine-donation-terms/',
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/ro-en/deals/ukraine-donation-terms/',
        },
      ],
    },
    cookie: {
      text: 'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/ro/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK',
    },
    market: {
      name: 'Takeaway.com',
      url: 'https://www.takeaway.com/ro/',
    },
    title:
      'Apel caritabil pentru criza din Ucraina - Termeni și condiții pentru clienț',
    one: [
      'Takeaway.com ("JET") și companiile din grupul său, colaborează cu UNHCR, o organizație caritabilă care sprijină refugiații din întreaga lume, pentru a strânge fonduri pentru a sprijini refugiații afectați de criza actuală din Ucraina (denumit "Apelul").  Detaliile despre UNHCR sunt următoarele: ',
      'Nume:  UNHCR Nederland',
      'Număr de înregistrare (RSIN): 82 39 59 636',
      'Locația de înregistrare: UNHCR Nederland face parte din Organizația Națiunilor Unite și își desfășoară activitatea în Țările de Jos. ',
      'Adresă: Alexanderveld 5, 2585 AN Den Haag',
    ],
    two: {
      text: 'Puteți face donații către UNHCR făcând clic pe următorul ',
      link: 'link',
      url: 'https://donate.unhcr.org/int/en/ukraine-emergency-justeat-ro-emg?utm_source=partnerships&utm_medium=partnerships&utm_campaign=HQ_PS_EN_UA___romania-justeat-bg-emg',
    },
    three:
      'Făcând clic pe link-ul de mai sus, sunteți de acord cu acești termeni și condiții.',
    four: 'Făcând clic pe link-ul de mai sus, veți fi direcționat către o pagină web controlată de UNHCR.  Accesul și utilizarea de către dvs. a paginii de internet a UNHCR vor fi supuse termenilor și condițiilor UNHCR sunt stabilite pe pagina lor de internet.',
    five: 'Recunoașteți că JET nu are niciun control asupra conținutului, funcționalității, securității sau oricărui alt aspect al site-ului web al UNHCR, iar JET nu oferă nicio garanție sau declarație (expresă sau implicită) în legătură cu acest site web.',
    six: 'Recunoașteți că orice date cu caracter personal colectate de site-ul web al UNHCR vor fi procesate de către UNHCR în conformitate cu avizul de confidențialitate al UNHCR, așa cum este disponibil pe site-ul lor web.',
    seven:
      'Pentru fiecare donație făcută către UNHCR de către un client JET folosind mecanismul de donație explicat mai sus, JET va face o donație către UNHCR cu o sumă egală, până la o valoare maximă globală totală agregată de 500.000 EUR pe toate piețele participante.',
    eight:
      'Apelul se va desfășura în perioada 04.03.2022 - 04.04.2022. JET poate prelungi sau scurta durata Apelului, la discreția sa exclusivă.',
    nine: 'JET își rezervă dreptul de a modifica unilateral acești Termeni și Condiții sau de a retrage Apelul în orice moment, fără notificare prealabilă, cu condiția ca donațiile făcute de clienții JET înainte de acest moment să continue să fie egalate în funcție de limita de donație menționată mai sus.',
    ten: {
      one: 'Se aplică toți termenii și condițiile standard din când în când pentru utilizarea site-ului web și a serviciilor ',
      two: '',
    },
    conditions: {
      link: 'Termeni și Condiții',
      url: 'https://www.takeaway.com/ro/conditii-de-utilizare',
    },
    privacy: {
      link: 'Declarație de confidențialitate',
      url: 'https://www.takeaway.com/ro/declaratie-privind-confidentialitatea',
    },
    copyright: '© 2022 Takeaway.com',
  },
}
